import bulmaCollapsible from "@creativebulma/bulma-collapsible";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { cleanJoin } from "../../utils/stringUtil";
import Box from "../box/Box";

function CollapsibleBox({ title, bulmaTitleSize = 5, children, className, titleOnClick, ...rest }) {
  const cIdRef = useRef(null);
  // Each collapsible element needs to have id assigned so here we generate a random one to avoid
  // having the same ids
  const [cId] = useState(`c${Math.floor(Math.random() * 100000)}`);
  // TODO Add test and maybe change name
  const [hideContent, setHideContent] = useState(true);

  useEffect(() => {
    new bulmaCollapsible(cIdRef.current);
    setHideContent(false);
  }, [cId]);

  return (
    <Box {...rest} className={cleanJoin(className)}>
      <div className={`is-size-${bulmaTitleSize}`}>
        <span className={titleOnClick ? "is-clickable" : ""} onClick={titleOnClick}>
          {title}
        </span>
        <a
          href={`#${cId}`}
          data-action="collapse"
          className="is-hidden-fullscreen"
          aria-label="more options"
        >
          <FontAwesomeIcon
            icon={faAngleDown} // toggle between up and down
            className="is-pulled-right has-text-grey"
          />
        </a>
      </div>
      <div id={cId} ref={cIdRef} className="is-collapsible">
        {children && (
          <div className={cleanJoin("is-pulled-left", "mt-2", hideContent ? "is-hidden" : "")}>
            {children}
          </div>
        )}
      </div>
    </Box>
  );
}

export default CollapsibleBox;
